<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style lang="scss">
@import './element-variables.scss';
html, body{
  padding: 0;
  margin: 0;
  height: 100%;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: $--color-text-primary;
  background: url("./assets/bg.jpg");
  background-size: 100% auto;
  height: 100%;
  overflow-y: scroll;
  padding: 0;
  box-sizing:border-box;
}
</style>



// WEBPACK FOOTER //
// src/App.vue